import BooleanField from 'src/pages/ProjectDetailsPage/components/JobForm/components/BooleanField';
import DateField from 'src/pages/ProjectDetailsPage/components/JobForm/components/DateField';
import DisabledTextField from 'src/pages/ProjectDetailsPage/components/JobForm/components/DisabledTextField';
import MultiSelectField from 'src/pages/ProjectDetailsPage/components/JobForm/components/MultiSelectField';
import NumberField from 'src/pages/ProjectDetailsPage/components/JobForm/components/NumberField';
import TextField from 'src/pages/ProjectDetailsPage/components/JobForm/components/TextField';

export default function resolveAttributesDynamicField(
  field: UCM.DynamicFieldType,
) {
  switch (field.type.code) {
    case 'boolean':
      return BooleanField;
    case 'multi-selectable':
    case 'single-selectable':
      return MultiSelectField;
    case 'date':
      return DateField;
    case 'number':
      return NumberField;
    case 'text':
    case 'long-input':
      return TextField;
    default:
      return DisabledTextField;
  }
}
